module.exports = __webpack_public_path__ + "static/media/tff.5fe52551.svg";